<template>
  <v-form @submit.prevent="onLocalSubmit" ref="formRef" class="mr-5 ml-5 mt-5 mb-5">
    <v-row dense >
      <v-col >
        <v-text-field v-model="round.data" type="date" outlined clearable :rules="requiredField"  >
          <template v-slot:label>
            <span>Data do Round <span style="color: red;">*</span></span>
          </template>
        </v-text-field>
      </v-col>
      <v-col >
        <v-autocomplete :loading="isLoadingResponsavel" v-model="round.responsavel" :items="responsavel" :item-text="formatResponsavel" item-value="id" label="Responsável" outlined clearable :rules="requiredField" return-object></v-autocomplete>
      </v-col>
      <v-col >
        <v-autocomplete :loading="isLoadingDesfecho" v-model="round.desfecho" :items="desfecho" item-text="nome" item-value="id" label="Desfecho" outlined clearable :rules="requiredField" return-object ></v-autocomplete>
      </v-col>
      
    </v-row>
    
    <v-row dense>  
        <v-col>
            <v-textarea v-model="round.ocorrencia" outlined clearable :rules="requiredField" :rows="7" auto-grow >
            <template v-slot:label>
                <span>Ocorrência <span style="color: red;">*</span></span>
            </template>
            </v-textarea>
        </v-col>
    </v-row>
    <v-row dense>  
        <v-col>
            <v-textarea v-model="round.meta" outlined clearable :rules="requiredField" :rows="7" auto-grow >
            <template v-slot:label>
                <span>Meta <span style="color: red;">*</span></span>
            </template>
            </v-textarea>
        </v-col>
    </v-row>
    <v-row dense>  
        <v-col>
            <v-textarea v-model="round.desfecho_final" outlined clearable  :rows="7" auto-grow  label="Desfecho Final">
            </v-textarea>
        </v-col>
    </v-row>
    <v-row class="justify-end" dense >
      <v-col class="text-end">
        <ConfirmButton :loading="isSubmitting" color="success">Salvar</ConfirmButton>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
import UtilsFunc from '../../service/utilsFunc';
import ConfirmButton from '../ConfirmButton.vue';
import '../../../src/assets/css/styles.css';
import api from '../../http';
import { mapGetters } from "vuex";

const { withCRUDUtils } = UtilsFunc

export default {
  name: "EditarRound",
  props: {
    onSubmit: Function,
    round: Object,

  },
  data: () => withCRUDUtils({
    isLoadingResponsavel: false,
    isLoadingDesfecho: false,
    isSubmitting: false,
    currentItem: {},
    isLoadingPaciente: false,
    paciente: [],
    responsavel: [],
    desfecho: [],
    requiredField: [
        e => e !== null && e !== undefined && e !== '' || 'Obrigatório'
    ],
    
  }),
  components: { ConfirmButton },
  methods: {
    async onLocalSubmit() {
      const isValidForm = await this.$refs.formRef.validate();
      if (!isValidForm) {
        this.$toast.error("Por favor, preencha todos os campos obrigatórios.");
        return;
      }
      this.isSubmitting = true;
      const fields = { 
        ...this.round,
        colaborador: this.round.colaborador.id,
        responsavel: this.round.responsavel.id,
        paciente: this.round.paciente.id,
        desfecho: this.round.desfecho.id,
        // colaborador: this.userData.id
      };
    //  console.log(fields)
      try {
        await this.onSubmit(fields);
      } catch (error) {
        this.$toast.error(`Desculpe! Aconteceu algo errado . Erro: ${error}`);
      } finally {
          this.isSubmitting = false;
      }
    },
    async getPaciente() {
      this.isLoadingPaciente = true;
      try {
        const { data } = await api.get(`/pacientes/app-pacientes/`);
        this.paciente = data.filter(item => item.ativo)
      } catch (error) {
        this.$toast.error(`Desculpe. Apresentou algum erro . ${error}`);
      } finally {
        this.isLoadingPaciente = false;
      }
    },
    async getResponsavel() {
      this.isLoadingResponsavel = true;
      try {
        const { data } = await api.get(`/contas/prestadores/`);
        this.responsavel = data
          .filter( item => item.is_active)
          .sort((a, b) => a.apelido.localeCompare(b.apelido));
        // console.log(this.responsavel)
      } catch (error) {
        this.$toast.error(`Desculpe. Apresentou algum erro . ${error}`);
      } finally {
        this.isLoadingResponsavel = false;
      }
    },
    async getDesfecho() {
        this.loadingDesfecho = true;
        try {
            const response = await api.get("/round/desfecho/");
            this.desfecho = response.data
            .filter(item => item.ativo)
            .sort((a, b) => a.nome.localeCompare(b.nome));
        } catch (error) {
            this.$toast.error(`Erro ao buscar desfechos: ${error}`);
        } finally {
            this.loadingDesfecho = false;
        }
    },

   
    formatDate(isoString) {
      if (!isoString) return '';
      const date = new Date(isoString);
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); 
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    lista() {
      return this.userData || {}
      
    },
    formatResponsavel(item) {
      if (!item) return '';
      return `${item.apelido} - ${item.especialidade?.nome || ''}`;
    },

  },
   computed: {
    ...mapGetters(['companyData', 'userData']),
   },
  mounted() {
    this.getDesfecho()
    this.getPaciente()
    this.getResponsavel()
    const agora = new Date();

    const yyyy = agora.getFullYear();
    const mm = String(agora.getMonth() + 1).padStart(2, '0');
    const dd = String(agora.getDate()).padStart(2, '0');

    this.currentItem.data = `${yyyy}-${mm}-${dd}`;



  },
}
</script>

